import api from "./api";

import { ModulockerTemplate } from "config/interfaces/ModulockerTemplate";

interface MessageResponse {
  message?: string;
  error?: {
    message: string;
  }
}

const create = async ({
  description,
  boxQty,
  boxes,
  serialNumber,
  sku,
}: ModulockerTemplate) => {
  try {
    return await api.post<ModulockerTemplate>("/api/template-modulocker", {
      description,
      sku,
      boxQty,
      serialNumber,
      boxes,
    });
  } catch (err) {
    return;
  }
};

const getAll = () => {
  return api.get<ModulockerTemplate[]>("/api/template-modulocker");
};

const getOne = (modulockerId: string) => {
  return api.get<ModulockerTemplate>(`/api/template-modulocker/${modulockerId}`);
};

const edit = (modulockerId: string, {
  description,
  boxQty,
  boxes,
  serialNumber,
  sku,
}: ModulockerTemplate) => {
  return api.put<ModulockerTemplate>(`/api/template-modulocker/${modulockerId}`, {
    description,
    sku,
    boxQty,
    serialNumber,
    boxes,
  });
};

const destroy = (modulockerId: string) => {
  return api.delete<MessageResponse>(`/api/template-modulocker/${modulockerId}`);
};

export { create, getAll, getOne, edit, destroy };
